import React from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage, SplitFormattedMessage } from '@zenbusiness/application-commons-intl';
import Divider from '@zenbusiness/zui/Divider';
import Heading from '@zenbusiness/zui/Heading';
import Link from '@zenbusiness/zui/Link';
import Stack from '@zenbusiness/zui/Stack';

import * as Styled from './Information.style';

import { messageFormatValues } from '../../../../utils/messageFormatValues';

const SubDescriptionComponent = ({ children }) => (
  <Styled.SubDescription>
    <Styled.StyledCheckIcon color="success" />
    {children}
  </Styled.SubDescription>
);

const Information = ({ items, hasIcon, hasNumber, hasDivider, disclaimers = [] }) => (
  <Styled.List>
    {items.map((item, index) => {
      const formattedDescription = hasIcon
        ? SplitFormattedMessage({
            id: item.description,
            delimiter: '\n',
            component: SubDescriptionComponent,
          })
        : null;

      return (
        <React.Fragment key={`${item.title}-${index.toString()}`}>
          <Styled.ListItem>
            {hasNumber && <Styled.IconStep>{index + 1}</Styled.IconStep>}
            <Stack gap={hasIcon ? 3 : 1}>
              {!!item.title && (
                <Heading size="md">
                  <FormattedMessage id={item.title} />
                </Heading>
              )}
              {!!item.description && (
                <Styled.Description color="secondary">
                  {hasIcon ? (
                    formattedDescription
                  ) : (
                    <FormattedMessage id={item.description} values={messageFormatValues} />
                  )}
                </Styled.Description>
              )}
              {item.link && (
                <Link to={item.link.href} target="_blank">
                  <FormattedMessage id={item.link.text} />
                </Link>
              )}
            </Stack>
          </Styled.ListItem>
          {hasDivider && index !== items.length - 1 && <Divider />}
        </React.Fragment>
      );
    })}
    {disclaimers?.length > 0 && (
      <>
        <Divider />
        <Styled.ListItem key="disclaimers">
          <Stack gap={1}>
            {disclaimers?.map((disclaimer) => (
              <Styled.Disclaimer key={disclaimer} size="sm" color="secondary">
                <FormattedMessage id={disclaimer} />
              </Styled.Disclaimer>
            ))}
          </Stack>
        </Styled.ListItem>
      </>
    )}
  </Styled.List>
);

Information.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  hasIcon: PropTypes.bool,
  hasNumber: PropTypes.bool,
  hasDivider: PropTypes.bool,
  disclaimers: PropTypes.arrayOf(PropTypes.string),
};

export default Information;
